<template>
  <span class="inline-block tooltip">
    <svg
      width="20"
      height="20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="cursor-pointer relative hover:opacity-75 transition-opacity duration-500 ease-in-out"
      @click="$modal.show(heading)"
      style="top:2px"
    >
      <path
        d="M19.833 9.881a9.5 9.5 0 0 0-9.5-9.5 9.5 9.5 0 1 0 0 19 9.5 9.5 0 0 0 9.5-9.5z"
        fill="#8587FD"
      />
      <path
        d="M6.126 7.029c0-.533.171-1.073.513-1.62.342-.547.842-1 1.498-1.359s1.422-.538 2.297-.538c.814 0 1.532.15 2.154.45.623.3 1.104.708 1.443 1.224.34.516.51 1.077.51 1.683 0 .477-.098.895-.291 1.254a3.836 3.836 0 0 1-.69.93c-.267.26-.745.7-1.435 1.316-.19.174-.343.327-.458.459a1.86 1.86 0 0 0-.257.362c-.056.11-.1.219-.13.328-.031.11-.077.301-.14.576-.106.584-.44.875-1 .875-.292 0-.538-.095-.737-.286-.199-.19-.298-.474-.298-.85 0-.47.073-.879.218-1.224.146-.345.34-.648.581-.909.241-.26.567-.57.976-.93.359-.313.618-.55.778-.71.16-.16.295-.338.404-.535.11-.196.164-.41.164-.64 0-.448-.167-.827-.5-1.135-.334-.309-.765-.463-1.292-.463-.617 0-1.071.156-1.363.467-.292.311-.538.77-.74 1.376-.191.634-.553.95-1.086.95-.314 0-.58-.11-.795-.332-.216-.221-.324-.461-.324-.72zm4.106 9.222c-.342 0-.64-.111-.896-.333-.255-.221-.383-.53-.383-.93 0-.353.124-.65.37-.891a1.25 1.25 0 0 1 .91-.362c.353 0 .65.12.891.362.241.241.362.538.362.892 0 .392-.126.701-.379.925a1.278 1.278 0 0 1-.875.337z"
        fill="#fff"
      />
    </svg>
    <modal
      :name="heading"
      :maxWidth="650"
      width="100%"
      height="100%"
      :adaptive="true"
    >
      <div class="flex flex-col modal-container p-5 text-center">
        <button @click="$modal.hide(heading)" class="close-btn">
          <svg viewBox="0 0 10 11" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.707.793a1 1 0 0 0-1.414 0L5 4.086 1.707.793A1 1 0 0 0 .293 2.207L3.586 5.5.293 8.793a1 1 0 1 0 1.414 1.414L5 6.914l3.293 3.293a1 1 0 0 0 1.414-1.414L6.414 5.5l3.293-3.293a1 1 0 0 0 0-1.414z"
              fill="#000646"
            />
          </svg>
        </button>
        <div class="max-w-2xl mx-auto pb-3">
          <h3 class="u-h2" v-html="heading" />
          <div v-html="content" />
        </div>
      </div>
    </modal>
  </span>
</template>

<script>
export default {
  props: ['heading', 'content'],
};
</script>

<style lang="scss">
.v--modal-box {
  pointer-events: none;
  .modal-container {
    pointer-events: all;
  }
}
.tooltip {
  .v--modal-box {
    background: transparent;
    box-shadow: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    pointer-events: none;
  }

  .u-h2 {
    font-size: 30px;
    text-align: center;
    margin-bottom: 1rem;
  }
  .modal-container {
    position: relative;
    background: #fff;
    min-height: 266px;
    padding: 55px 1rem 45px 1rem;
    width: 100%;
    pointer-events: all;
  }

  .close-btn {
    position: absolute;
    top: 26px;
    right: 28px;
    height: 14px;
    width: 14px;
  }
}
</style>
